import FeatureSkeleton, {
  FeatureSkeletonProps,
} from '@woolworthslimited/core-components-react/skeleton/skeleton';
import clsx from 'clsx';

import styles from './recipe-ghost.module.scss';
import { FeatureRecipeTileGhostProps } from './recipe-ghost.types';

const FeatureRecipeTileGhost = (props: FeatureRecipeTileGhostProps) => {
  const { variation = 'vertical', hasBorder = true } = props;
  const featureSkeletonProps: FeatureSkeletonProps = {
    animation: 'wave',
    variant: 'rectangular',
  };

  return (
    <div
      className={clsx(
        styles['recipe-tile-ghost'],
        styles[`${variation}`],
        hasBorder && [styles['border']]
      )}
    >
      <div className={styles['recipe-tile-ghost-top']}>
        <div className={styles['recipe-tile-ghost-image']}>
          <FeatureSkeleton {...featureSkeletonProps} height="100%" />
        </div>

        <div className={styles['recipe-tile-ghost-container']}>
          <div className={styles['recipe-tile-ghost-container-top']}>
            <div className={styles['recipe-tile-ghost-margin']}>
              <FeatureSkeleton
                {...featureSkeletonProps}
                width="60%"
                height="2rem"
              />
            </div>

            <FeatureSkeleton
              {...featureSkeletonProps}
              width="80%"
              height="2rem"
            />
          </div>
          <div className={styles['recipe-tile-ghost-container-bottom']}>
            <div
              className={clsx(
                styles['recipe-tile-ghost-margin'],
                styles['non-stretch-only']
              )}
            >
              <FeatureSkeleton
                {...featureSkeletonProps}
                width="100%"
                height="1.5rem"
              />
            </div>
            <div className={styles['recipe-tile-ghost-margin']}>
              <FeatureSkeleton
                {...featureSkeletonProps}
                width="70%"
                height="1.125rem"
              />
            </div>

            <FeatureSkeleton
              {...featureSkeletonProps}
              width="60%"
              height="1.125rem"
            />
          </div>
        </div>
      </div>

      {variation === 'vertical' && (
        <div className={styles['recipe-tile-ghost-bottom']}>
          <div
            className={clsx(
              styles['recipe-tile-ghost-margin'],
              styles['non-stretch-only']
            )}
          >
            <FeatureSkeleton {...featureSkeletonProps} height="1.5rem" />
          </div>

          <FeatureSkeleton {...featureSkeletonProps} height="2rem" />
        </div>
      )}
    </div>
  );
};

export default FeatureRecipeTileGhost;
